var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"cursor":"pointer","padding":"16px 16px 0","display":"inline-block"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"el-icon-back"},[_vm._v("返回")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }